import { SpecialAnchorTypes, ToolBaseTypes, ToolTypes } from '@labradorsports/constants';

import {
    generateShadingAnchors,
    generateShadingSelectedAnchors,
    handleShadingDrag,
    handleShadingDragEnd,
} from '../utils/index.js';

import { PluginContext } from './api.js';

export default {
    baseType: ToolBaseTypes.PIECE,
    types: [ToolTypes.ELLIPSE, ToolTypes.RECTANGLE],
    specialAnchorTypes: [SpecialAnchorTypes.SHADING_RESIZE, SpecialAnchorTypes.SHADING_ROTATE],
    generateAnchors: generateShadingAnchors,
    generateSelectedAnchors: generateShadingSelectedAnchors,
    handleDragEnd: handleShadingDragEnd,
    handleDrag: handleShadingDrag,
} as PlayPlugin<PluginContext>;
